import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../images/JACAiLogo.png";
import "../css/Header.css";

export default function Header() {
  return (
    <Navbar
      expand="md"
      sticky="top"
      className="main-navbar glass-nav"
    >
      <Container>
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="d-flex align-items-center navbar-brand-custom"
        >
          <div className="logo-wrapper">
            <img src={logo} alt="Logo" className="navbar-logo me-2" />
          </div>
          <span className="brand-text">JACAi</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" className="navbar-toggle-custom" />

        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto align-items-center nav-links">
            <Nav.Link as={NavLink} to="/">
              ChatWithJacai
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
